// extracted by mini-css-extract-plugin
export default {"splitTextParent":"SplitText_splitTextParent__H1eCM","word":"SplitText_word__edP3h","space":"SplitText_space__HXUBV"};